var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiscSale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9998 0.345215L8.33984 5.99521V1.65521H0.339844V9.65521H8.33984V5.99521L13.9998 11.6552H10.3398V19.6552H18.3398V11.6552H13.9998L19.6598 5.99521L13.9998 0.345215ZM16.8298 6.00521L13.9998 3.17521L11.1698 6.00521L13.9998 8.83521L16.8298 6.00521ZM6.33984 7.65521V3.65521H2.33984V7.65521H6.33984ZM16.3398 13.6552V17.6552H12.3398V13.6552H16.3398ZM6.33984 17.6552V13.6552H2.33984V17.6552H6.33984ZM0.339844 11.6552H8.33984V19.6552H0.339844V11.6552Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiscSale);
export default __webpack_public_path__ + "static/media/MiscSale.bd13cf3bb1de85bbc2f3b806f84cafa7.svg";
export { ForwardRef as ReactComponent };